var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('questions',{attrs:{"areas":_vm.areas,"questions":_vm.questions},on:{"on-active":function($event){_vm.$emit('on-active', $event)},"show-questions":function($event){_vm.$emit('show-questions', $event)},"quantity-selected":function($event){_vm.$emit('quantity-selected', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a212348","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/step-three.vue
// module id = 3390
// module chunks = 21